import React, { Component } from 'react'

class RoadMap extends Component {
    render(){
        return(
            <div className=' w3-container my-profile-container'>
                <h4 className='w3-center'><b>Project RoadMap</b></h4>
                <div className="w3-container w3-margin-bottom my-framework">
                            <div className="w3-card-2 w3-white w3-round-large w3-center">
                                <header className="w3-container w3-light-grey ">
                                <h6><b>Project Framework</b></h6>
                                </header>
                                <div className="w3-row">
                                <img className='my-stage' src='./images/framework.png' alt='Frame work'/>
                                </div>            
                            </div>
                        </div>

                        <table className="w3-table-all w3-margin-bottom"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='5'>Detail Activity</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Work Package(WP)</b></td>
                                <td><b>Activity</b></td>
                                <td><b>Proposed Start</b></td>
                                <td><b>Proposed Completion</b></td>
                                <td><b>Completion Status</b></td>
                                
                                
                               
                            </tr>
                            <tr>
                                <td><b>Activity 1</b></td>
                                <td colSpan='4' className='w3-center'> <b>Design & Development of Solar Agriculture Farm</b></td>
                                
                            

                               
                            </tr>
                            <tr>
                                <td> Activity 1.1</td>
                                <td> Foundation and fabrication work</td>
                                <td> Mar 2019</td>
                                <td> June 2019</td>
                                <td> 100%</td>
                              
                            </tr>
                            <tr>
                                <td> Activity 1.2</td>
                                <td> Fixing of solar modules, underground cabling</td>
                                <td> June 2019</td>
                                <td> Oct 2019</td>
                                <td> 100%</td>
                              
                            </tr>
                            <tr>
                                <td> Activity 1.3</td>
                                <td> Inverter commissioning</td>
                                <td> Mar 2020</td>
                                <td> Jan 2021</td>
                                <td> 100%</td>
                              
                            </tr>
                            <tr>
                                <td> Activity 1.4</td>
                                <td> VRF battery commissioning and DC microgrid</td>
                                <td>Oct 2019</td>
                                <td> Dec 2019</td>
                                <td> 100%</td>
                              
                            </tr>
                            <tr>
                                <td><b>Activity 2</b></td>
                                <td colSpan='4' className='w3-center'> <b>Design & Development of Solar Powered Value Chain Machinery</b></td> 
                            </tr>
                            <tr>
                                <td> Activity 2.1</td>
                                <td> Design & fabrication of electric thrasher, reaper, cultivator</td>
                                <td> Apr 2019</td>
                                <td> June 2019</td>
                                <td> 100%</td>
                              
                            </tr>
                            <tr>
                                <td> Activity 2.2</td>
                                <td> Design & fabrication of electric chiller system for Dairy</td>
                                <td> Nov 2020</td>
                                <td> Aug 2021</td>
                                <td> 100%</td>
                              
                            </tr>
                            <tr>
                                <td><b>Activity 3</b></td>
                                <td colSpan='4' className='w3-center'> <b>Integration of Renewable Energy Resources and Analysis with Proper Modeling and Simulation</b></td> 
                            </tr>
                            <tr>
                                <td> Activity 3.1</td>
                                <td> Integration of Online UPS with GCI</td>
                                <td> Dec 2020</td>
                                <td> Oct 2021</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 3.2</td>
                                <td> Design of Controllers for Online UPS and GCI</td>
                                <td> Dec 2020</td>
                                <td> Oct 2021</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 3.3</td>
                                <td> Integration of Bio-gas plant</td>
                                <td> July 2021</td>
                                <td> Sept 2021</td>
                                <td> 60%</td> 
                            </tr>
                            <tr>
                                <td> Activity 3.4</td>
                                <td> Integration of Battery, Solar and AC Sources</td>
                                <td> Aug 2020</td>
                                <td> Jan, 2022</td>
                                <td> 50%</td> 
                            </tr>
                            <tr>
                                <td> Activity 3.5</td>
                                <td> Modeling and Design of online UPS(120kW) System</td>
                                <td> Dec 2019</td>
                                <td> Oct, 2020</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 3.6</td>
                                <td> Modeling and Design of Grid Connected Inverters(GCI)</td>
                                <td> Dec 2019</td>
                                <td> Oct, 2020</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 3.7</td>
                                <td> Modeling of SPV</td>
                                <td> July 2018</td>
                                <td> Sept, 2018</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 3.8</td>
                                <td> Modeling of Battery</td>
                                <td> July 2018</td>
                                <td> Sept, 2018</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 3.9</td>
                                <td> Modeling of AC Source</td>
                                <td> July 2018</td>
                                <td> Sept, 2018</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td><b>Activity 4</b></td>
                                <td colSpan='4' className='w3-center'> <b>Dynamic Monitoring of System states of Hybrid Microgrid</b></td> 
                            </tr>
                            <tr>
                                <td> Activity 4.1</td>
                                <td> Identification and Analysis of Switching Transients</td>
                                <td> Jun 2020</td>
                                <td> Jan, 2022</td>
                                <td> 50%</td> 
                            </tr>
                            <tr>
                                <td> Activity 4.2</td>
                                <td> Controller Design to Minimize switching transients</td>
                                <td> Jun 2020</td>
                                <td> Jan, 2022</td>
                                <td> 50%</td> 
                            </tr>
                            <tr>
                                <td> Activity 4.3</td>
                                <td> Remote monitoring, performance analysis, analytics for efficient operation</td>
                                <td> Feb 2021</td>
                                <td> Dec 2021</td>
                                <td> 50%</td> 
                            </tr>
                            <tr>
                                <td><b>Activity 5</b></td>
                                <td colSpan='4' className='w3-center'> <b>Design and Development of Lab-setup</b></td> 
                            </tr>
                            <tr>
                                <td> Activity 5.1</td>
                                <td> Identification of Space for Lab setup</td>
                                <td> July, 2018</td>
                                <td> July, 2018</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 5.2</td>
                                <td> Development of Lab setup</td>
                                <td> July 2018</td>
                                <td> Oct, 2019</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 5.3</td>
                                <td> Development of battery room</td>
                                <td> Jan 2019</td>
                                <td> Jan, 2019</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 5.4</td>
                                <td> Selection of PV Panels</td>
                                <td> July 2018</td>
                                <td> Mar, 2019</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 5.5</td>
                                <td> Configuration of PV Panels</td>
                                <td> Jan 2019</td>
                                <td> July, 2020</td>
                                <td> 100%</td> 
                            </tr>
                  
                            <tr>
                                <td> Activity 5.6</td>
                                <td> Different type of load identification</td>
                                <td> July 2018</td>
                                <td> Oct 2018</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 5.7</td>
                                <td> Battery Bank Specification </td>
                                <td> Oct 2018</td>
                                <td> Jan, 2020</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 5.8</td>
                                <td> Installation of Battery Bank</td>
                                <td> June 2019</td>
                                <td> Jan-2020</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 5.9</td>
                                <td> Battery Bank Testing</td>
                                <td> Jan 2020</td>
                                <td> Jan, 2020</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 5.10</td>
                                <td> Master Inverter Design</td>
                                <td> July 2018</td>
                                <td> Nov, 2018</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td> Activity 5.11</td>
                                <td> Different types of converter selection</td>
                                <td> July 2018</td>
                                <td> March, 2021</td>
                                <td> 100%</td> 
                            </tr>
                            <tr>
                                <td><b>Activity 6</b></td>
                                <td colSpan='4' className='w3-center'> <b>Analysis of Data Gathered</b></td> 
                            </tr>
                            <tr>
                                <td> Activity 6.1</td>
                                <td> Analysis of  Lab data</td>
                                <td> Aug 2020</td>
                                <td> Jan, 2022</td>
                                <td> 50%</td> 
                            </tr>
                            <tr>
                                <td> Activity 6.2</td>
                                <td> Analysis of  Field demonstration data</td>
                                <td> Aug 2020</td>
                                <td> Jan, 2022</td>
                                <td> 50%</td> 
                            </tr>
                         
                            
                            
                            </tbody>
                        </table>

            </div>
        )}}

export default RoadMap